import React, { ChangeEvent, memo } from 'react';
import styled from 'styled-components';
import theme from '@/styles/theme';
import StyledRadio from '../atoms/StyledRadio';
import { DataValueType } from '../../types/types';

type StyledRadioGroupProps = {
	margin?: string;
	title: string;
	description?: string;
	descriptionColor?: string;
	items: DataValueType[];
	name: string;
	value: string | number;
	onChange: (e: ChangeEvent<HTMLInputElement>) => void;
	disabled?: boolean;
}

const RadioGroup = ({
	margin,
	title,
	description,
	descriptionColor,
	items = [],
	name,
	value,
	onChange,
	disabled
}: StyledRadioGroupProps) => {
	return (
		<Wrapper $margin={margin}>
	        <Title>{title}</Title>
	        <Group>
		        {items.map(item => (
			        <StyledRadio
				        key={`${name}-${item.value}`}
				        margin="0 20px 0 0"
				        label={item.title}
				        radioId={`${name}-${item.value}`}
				        name={name}
				        value={item.value}
				        dataValue={item?.option}
				        onChange={onChange}
				        checked={value}
				        disabled={disabled}
			        />
		        ))}
	        </Group>
			{description && <Description $color={descriptionColor}>{description}</Description>}
        </Wrapper>
	);
};

export default memo(RadioGroup);

const Wrapper = styled.div<{ $margin?: string; }>`
  margin: ${({ $margin }) => $margin ? $margin : '0 0 24px'};
`;
const Title = styled.div`
  font-size: 14px;
  margin-bottom: 20px;
`;
const Group = styled.div`
  display: flex;
  align-items: flex-end;
`;
const Description = styled.p<{ $color?: string; }>`
  ${theme.typography.label};
  color: ${({ $color }) => $color ? $color : theme.colors.deepGrayFontColor};
  margin-top: 12px;
`;
